import { render, staticRenderFns } from "./GetWindowSize.vue?vue&type=template&id=faf2f734&"
import script from "./GetWindowSize.vue?vue&type=script&lang=ts&"
export * from "./GetWindowSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports